import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, FormsModule, Validators, FormArray } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { InputDatetimeComponent } from 'src/app/shared/components/inputs/input-datetime/input-datetime.component';
import { InputNumberComponent } from 'src/app/shared/components/inputs/input-number/input-number.component';
import { TrasmissioneReportNetService } from '../trasmissione-reportnet.service';

@Component({
  selector: 'app-trasmissione-reportnet3',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    FormsModule,
    MatDatepickerModule,
    InputDatetimeComponent,
    InputNumberComponent
  ],
  templateUrl: './invio-dati-page.component.html',
  styleUrl: './invio-dati-page.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvioDatiPageComponent implements OnInit {

  @Input() form?: FormGroup;

  constructor(private trasmissioneReportNetService: TrasmissioneReportNetService) { }

  supCause: any = [
    { codice: 'CS1', descrizione: '(CS1) - inquinamento accidentale' },
    { codice: 'CS2', descrizione: '(CS2) - alluvione' },
    { codice: 'CS3', descrizione: '(CS3) - focolaio epidemico' },
    { codice: 'CS4', descrizione: '(CS4) - eventi disastrosi (naturali, incendi, esplosioni…)' },
    { codice: 'CS5', descrizione: '(CS5) - siccità prolungata' },
    { codice: 'CS6', descrizione: '(CS6) - guasto al trattamento' },
    { codice: 'CS7', descrizione: '(CS7) - interruzione di servizio non pianificata' },
    { codice: 'CS8', descrizione: '(CS8) - carenza idrica' },
    { codice: 'CS9', descrizione: '(CS9) - altra categoria' },
    { codice: 'CS10', descrizione: '(CS10) - non nota' }
  ]
  azioni: any = [
    {
      codice: 'AC1',
      descrizione: 'correlata alla captazione: azioni per risolvere o mitigare la causa (C1)'
    },
    {
      codice: 'AC2',
      descrizione: 'correlata alla captazione: azioni volte alla sostituzione della sorgente (C2)'
    },
    {
      codice: 'AC3',
      descrizione: 'Sistema di distribuzione interno: Sostituzione, disconnessione o riparazione di componenti difettosi (D1)'
    },
    {
      codice: 'AC4',
      descrizione: 'Sistema di distribuzione interno: Pulizia, lavaggio e/o disinfezione dei componenti contaminati (D2)'
    },
    {
      codice: 'AC5',
      descrizione: 'Azioni di emergenza per la salute e la sicurezza dei consumatori: Notifica e\n istruzioni ai consumatori, ad esempio divieto di utilizzo, ordine di ebollizione dell\'acqua, limitazioni temporanee del consumo (E1)'
    },
    {
      codice: 'AC6',
      descrizione: 'Azioni di emergenza per la salute e la sicurezza dei consumatori: Fornitura di un approvvigionamento alternativo temporaneo di acqua potabile, ad esempio acqua\n in bottiglia, acqua in contenitori, autocisterne (E2)'
    },
    {
      codice: 'AC7',
      descrizione: 'Azioni di emergenza per la salute e la sicurezza dei consumatori:\n restrizioni per gli utenti sensibili (E3)'
    },
    {
      codice: 'AC8',
      descrizione: 'Azioni di emergenza per la salute e la sicurezza dei consumatori: Divieto\n di utilizzo (E4)'
    },
    {
      codice: 'AC9',
      descrizione: 'Rete di distribuzione pubblica: Sostituzione, disconnessione o riparazione di componenti difettosi (P1)'
    },
    {
      codice: 'AC10',
      descrizione: 'Rete di distribuzione pubblica: Pulizia, lavaggio e/o disinfezione dei componenti contaminati (P2)'
    },
    {
      codice: 'AC11',
      descrizione: 'Misure di sicurezza per prevenire l\'accesso non autorizzato (S1)'
    },
    {
      codice: 'AC12',
      descrizione: 'Relativo al trattamento: Stabilire, potenziare o migliorare il trattamento (T1)'
    },
    {
      codice: 'AC13',
      descrizione: 'nessuna'
    },
    {
      codice: 'AC14',
      descrizione: 'altra'
    }
  ];



  ngOnInit(): void {
    this.form?.valueChanges.subscribe(val => {
   
    })

    this.form?.get('superamento')?.valueChanges.subscribe(superamento => {
      this.updateStateGiustificazione(superamento, this.form?.get('superamentoNonSignificativo')?.value);
    })

    this.form?.get('superamentoNonSignificativo')?.valueChanges.subscribe(supNonSignificativo => {
      this.updateStateGiustificazione(this.form?.get('superamento')?.value, supNonSignificativo);
      this.updateStateAltriCampi(supNonSignificativo);
    })
  }

  updateStateGiustificazione(superamento: boolean, supNonSignificativo: boolean) {
    const control = this.form?.get('superamentoNonSignificativoGiustificazione');
    if (superamento && !supNonSignificativo) {
      control?.reset();
      control?.disable();
    } else {
      control?.enable();
    }
  }

  updateStateAltriCampi(supNonSignificativo: boolean) {
    const popolazione = this.form?.get('superamentoPopolazioneInteressata');
    const supDataInizio = this.form?.get('superamentoDataInizio');
    const supDataFine = this.form?.get('superamentoDataFine');
    const supCausa = this.form?.get('superamentoCausa');
    const azCorrettiva = this.form?.get('superamentoAzioneCorrettiva');
    const azCorrettivaDataInizio = this.form?.get('superamentoAzioneCorrettivaDataInizio');
    const azCorrettivaDataFine = this.form?.get('superamentoAzioneCorrettivaDataFine');

    if (supNonSignificativo) {
      popolazione?.reset();
      supDataInizio?.reset();
      supDataFine?.reset();
      supCausa?.reset();
      azCorrettiva?.reset();
      azCorrettivaDataInizio?.reset();
      azCorrettivaDataFine?.reset();
      popolazione?.disable();
      supDataInizio?.disable();
      supDataFine?.disable();
      supCausa?.disable();
      azCorrettiva?.disable();
      azCorrettivaDataInizio?.disable();
      azCorrettivaDataFine?.disable();
    } else {
      popolazione?.enable();
      supDataInizio?.enable();
      supDataFine?.enable();
      supCausa?.enable();
      azCorrettiva?.enable();
      azCorrettivaDataInizio?.enable();
      azCorrettivaDataFine?.enable();
    }
  }

  
  get superamentoAzioneCorrettiva(): any {
    return this.form?.get('superamentoAzioneCorrettiva') as any;
  }
  notSUbmit(e:any){
   e.preventDefault()
  }
  //continua da qui
  addAzioniFormArray(event: any, codice: string) {
    const formArray: FormArray = this.superamentoAzioneCorrettiva;
  
    // Rimuove eventuali valori null prima di ogni operazione
    formArray.controls = formArray.controls.filter(control => control.value !== null);
  
    if (event.checked) {
      formArray.push(new FormControl(codice));
    } else {
      const index = formArray.controls.findIndex(el => el.value === codice);
      if (index >= 0) {
        formArray.removeAt(index);
      }
    }
  }
  

  setSupNonSign() {
    if (!this.form?.value.superamento) {
      if(this.form?.value.superamentoNonSignificativo){
        this.form.value.superamentoNonSignificativo! = false;
 
      }

      this.form?.get("superamentoNonSignificativoGiustificazione")?.reset()
      this.form?.get("superamentoPopolazioneInteressata")?.reset()
      this.form?.get("superamentoDataInizio")?.reset()
      this.form?.get("superamentoDataFine")?.reset()
      this.form?.get("superamentoCausa")?.reset()
      this.form?.get("superamentoAzioneCorrettiva")?.disable()
      this.form?.get("superamentoAzioneCorrettivaDataInizio")?.reset()
      this.form?.get("superamentoAzioneCorrettivaDataFine")?.reset()
    }
  }
  toLocalISOString(date:any) {
    let tzOffset = date.getTimezoneOffset() * 60000; // offset in milliseconds
    let localDate = new Date(date.getTime() - tzOffset);
    let localISO = localDate.toISOString().slice(0, 19); // Ottiene solo la parte della data e dell'ora senza "Z"
    return localISO;
}
  onSubmit() {
   

    let dataToSend = {
      uuid: this.form?.value.uuid,
      dataOraPrelievo:this.toLocalISOString( new Date(this.form?.value.dataOraPrelievo)),
      parametro: this.form?.value.parametro,
      tipologiaPuntoDiConformita: this.form?.value.tipologiaPuntoDiConformita,
      superamento: this.form?.value.superamento,
      superamentoNonSignificativo: this.form?.value.superamentoNonSignificativo,
      superamentoNonSignificativoGiustificazione: this.form?.value.superamentoNonSignificativoGiustificazione ?  this.form?.value.superamentoNonSignificativoGiustificazione : null,
      superamentoPopolazioneInteressata: this.form?.value.superamentoPopolazioneInteressata ? this.form?.value.superamentoPopolazioneInteressata : null,
      superamentoDataInizio: this.form?.value.superamentoDataInizio ? this.form?.value.superamentoDataInizio : null,
      superamentoDataFine: this.form?.value.superamentoDataFine ? this.form?.value.superamentoDataFine : null,
      superamentoCausa: this.form?.value.superamentoCausa ? this.form?.value.superamentoCausa : null,
      superamentoAzioneCorrettiva: this.form?.value.superamentoAzioneCorrettiva,
      superamentoAzioneCorrettivaDataInizio: this.form?.value.superamentoAzioneCorrettivaDataInizio ? this.form?.value.superamentoAzioneCorrettivaDataInizio : null,
      superamentoAzioneCorrettivaDataFine: this.form?.value.superamentoAzioneCorrettivaDataFine ? this.form?.value.superamentoAzioneCorrettivaDataFine : null
    }

    this.trasmissioneReportNetService.sendReportnet('', dataToSend)
    .subscribe((data: any) => {
      
    })
  }
}
